import React from 'react';
import { Gallery } from '../ui/Gallery';
import ResponsiveImage from '../ui/ResponsiveImage';
import ObjectUtils from '../utils/ObjectUtils';
export default class ContentBuilder
{
	static build(items, linkIcon = null)
	{
		if(!Array.isArray(items)) return;
		return items.map((e, i)=>{
			let tag = e.tag;
			if(!tag) tag = 'div';
			let props = ObjectUtils.filter(e, ['tag', 'content']);
			let className = [];
			if(e['className']) className = className.concat(e['className']);
			props['key'] = i;
			let content = e.content;
			if(Array.isArray(content)) content = this.build(content, linkIcon);
			else content = this.linkify(content, linkIcon);
			let el;
			if(tag == 'youtube')
			{
				className.push('youtube');
				return (<div key={i} className={className.join(' ')}>
					<iframe src={'//youtube.com/embed/' + e.id}></iframe>
					{
						(e['description'])?
						(
							<div className='description'>{this.linkify(e['description'], linkIcon)}</div>
						):null
					}
				</div>)
			}else if(tag == 'gallery')
			{
				return (
					<Gallery key={'g_' + i} {...e}></Gallery>
				)
			}else if(tag == 'img'){
				el = (<ResponsiveImage {...e} data={e}></ResponsiveImage>)
			}else
			{

				el = React.createElement(tag, props, content);
			}

			if(tag == 'img')
			{
				className.push('img');
				return (<div key={i} className={className.join(' ')}>
					{el}
					{
						(e['description'])?
						(
							<div className='description'>{this.linkify(e['description'], linkIcon)}</div>
						):null
					}
				</div>)
			}else
			{
				return el;
			}
		});
	}

	static linkify(content:string, Icon = null)
	{
		if(!content) return content;
		let splitted = content.split(/(\[\[.*?\]\])/);
		let o;
		return splitted.map((e, i)=>{
			if(o = /^\[\[(.*?)\]\]$/.exec(e))
			{
				let link, label;
				link = label = o[1];
				if(o = o[1].split('|'))
				{
					if(o.length > 1)
					{
						link = o[0];
						label = o[1];
					}
				}
				return (
					<a href={link} key={Math.random()} target='_blank' className='link'>{label}{(Icon)?(<Icon></Icon>):null}</a>
				);
			}else{
				return e;
			}
		});
	}
}